<template>
  <div class="Public-Notice" :style="NoticeStyle">
    {{Notice}}
  </div>
</template>

<script>
export default {
  name: "PublicNotice",
  data(){
    return{
    }
  },
  computed: {
    Notice: function () {
      return this.$store.state.NOTICECONTENT;
    },
    NoticeStyle:function (){
      return this.$store.state.NOTICESTYLE;
    }
  }
}
</script>